import React from "react"

import { Row, Col, Card, CardBody, CardTitle,Spinner } from "reactstrap"
import { Link } from "react-router-dom"

import ApexRadial from "./ApexRadial"
import { expenceStatistics } from "helpers/fakebackend_helper";
import { useQuery } from "react-query";



const MonthlyEarning = () => {
  const { data, isLoading } = useQuery('expense_stat', expenceStatistics, {
    staleTime: 120000,
    refetchOnWindowFocus: false,
  });
  return (
    <React.Fragment>
      {" "}
      <Card className="py-5">
        <CardBody>
          <CardTitle className="mb-4">Monthly Expense</CardTitle>
          <Row>
            <Col sm="6">
              {isLoading ? (
                <div className="d-flex justify-content-center align-items-center">
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <>
                  <p className="text-muted">This month</p>
                  <h3>€ {data?.current_month_total_expense}</h3>
                  <p className="text-muted">
                    <span className="text-success me-2">
                      {" "}
                      {isFinite((data?.current_month_total_expense - data?.last_month_total_expense) / data?.last_month_total_expense * 100) ? ((data?.current_month_total_expense - data?.last_month_total_expense) / data?.last_month_total_expense * 100)?.toFixed(1) : 'N/A'} %
                    </span>{" "}
                    From previous period
                  </p>
                  <div className="mt-4">
                    <Link
                      to="/expense"
                      className="btn btn-primary  btn-sm"
                      style={{ backgroundColor: "#2F8C47" }}
                    >
                      View More <i className="mdi mdi-arrow-right ms-1"></i>
                    </Link>
                  </div>
                </>
              )}
            </Col>
            <Col sm="6">
              <div className="mt-4 mt-sm-0">
                <ApexRadial />
              </div>
            </Col>
          </Row>
         
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonthlyEarning
